import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { StringKeys } from '../../resources/strings/StringKeys';

const ErrorComponent = ({ error }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="80vh"
      bgcolor="background.default"
      padding={3}
    >
      <ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h6" align="center">
        {t(StringKeys.AN_ERROR_OCCURRED_PLEASE_REFRESH_YOUR_BROWSER)}{' '}
        {t(StringKeys.IF_THE_ISSUE_PERSISTS_PLEASE_CONTACT_SUPPORT)}
      </Typography>
      <Typography variant="body1" align="center">
        Error Code: {error}
      </Typography>
    </Box>
  );
};

export default ErrorComponent;
